<template>
	<div
		v-if="items && items.length > 0"
		class="errors"
		data-cy="errors"
	>
		<div
			v-for="(item, index) in items"
			:key="index"
			class="error"
			data-cy="error"
		>
			<helio-icon
				token="times"
				weight="light"
			/>

			{{ item }}
		</div>
	</div>
</template>

<script>
import Icon from '../icon/Icon.vue';

export default {
	components: {
		'helio-icon': Icon,
	},
	props: {
		items: {
			type: Array,
			required: false,
			default: () => [],
		},
	},
};
</script>

<style lang="scss" scoped src="./errors.scss" />
